import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { LatestOfferRow } from '../interfaces/latestOffers.interface';

export const latestOffersApi = {
  async get(companyId?: number, direction?: ShippingDirection): Promise<LatestOfferRow[]> {
    const params: Record<string, string | number> = {};
    if (typeof companyId === 'number') params.companyId = companyId;
    if (direction) params.direction = direction;
    const response = await http.get('/dashboard/latest-offers', { params });
    return (response.data?.data as LatestOfferRow[]) ?? [];
  },
};
